import { Link } from 'react-router-dom';
import logo from '../assets/logo.webp';
import appStoreBadge from '../assets/Download_on_the_App_Store_Badge_US-UK_RGB_wht_092917.svg';
import { trackAppStoreClick } from '../analytics';

const navGroups = [
  {
    label: 'Product',
    links: [
      { label: 'Home', href: '#home' },
      { label: 'Features', href: '#features' },
      { label: 'Download', href: 'https://apps.apple.com/us/app/gymbud-pro/id6478331872', external: true },
    ],
  },
  {
    label: 'Company',
    links: [
      { label: 'About Us', href: 'https://miguelramosgonz.wixsite.com/gymbud-pro/about-us', external: true },
      { label: 'Contact Us', href: '/contact' },
    ],
  },
  {
    label: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of Service', href: '/terms-of-service' },
      { label: 'FAQ', href: '/faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="contact" className="bg-brand-section-dark border-t border-white/10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#home" className="flex items-center gap-2 mb-4">
              <img src={logo} alt="GymBud Pro" className="w-9 h-9 rounded-xl object-cover" />
              <span className="text-white font-bold text-lg">GymBud Pro</span>
            </a>
            <p className="text-white/50 text-sm leading-relaxed mb-5">
              The free workout logger for bodybuilders and powerlifters. Track smarter, lift harder.
            </p>
            <div className="text-white/40 text-sm space-y-0.5">
              <p>Toronto, ON</p>
              <p>Canada</p>
            </div>

            {/* App Store badge */}
            <a
              href="https://apps.apple.com/us/app/gymbud-pro/id6478331872"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackAppStoreClick('footer')}
              className="inline-block mt-5 hover:opacity-90 hover:scale-105 transform transition-all duration-200"
            >
              <img src={appStoreBadge} alt="Download on the App Store" className="h-10 w-auto" />
            </a>
          </div>

          {/* Nav groups */}
          {navGroups.map((group) => (
            <div key={group.label}>
              <h3 className="text-white text-sm font-bold uppercase tracking-wider mb-4">
                {group.label}
              </h3>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.external || link.href.startsWith('#') ? (
                      <a
                        href={link.href}
                        target={link.external ? '_blank' : undefined}
                        rel={link.external ? 'noopener noreferrer' : undefined}
                        className="text-white/50 hover:text-white/90 text-sm transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-white/50 hover:text-white/90 text-sm transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm text-center sm:text-left">
            © {new Date().getFullYear()} GymBud Pro. All rights reserved.
          </p>
          <p className="text-white/30 text-xs">
            Made with 💪 in Toronto
          </p>
        </div>
      </div>
    </footer>
  );
}
